export const stripeThemeAppearance = {
  theme: 'flat',
  variables: {
    colorPrimary: '#E5E5E5',
    colorBackground: '#F6F8FA',
    colorText: '#30313d',
    colorDanger: '#df1b41',
    fontFamily: '"GTFlexa", system-ui, sans-serif',
    spacingUnit: '5px',
    borderRadius: '4px',
  },
};
